import { usePathname } from 'next/navigation'

export default function useIsOptionsPage(): boolean {
  const pathname = usePathname()
  return pathname.startsWith('/options')
}
